module.exports = __webpack_public_path__ + "static/img/reestr_imush.83df3eb5.png";